import { render, staticRenderFns } from "./TypeTwo.vue?vue&type=template&id=69c26c58&"
import script from "./TypeTwo.vue?vue&type=script&lang=js&"
export * from "./TypeTwo.vue?vue&type=script&lang=js&"
import style0 from "./TypeTwo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports